import useSWR from 'swr';
import { EngineService } from '@/services/engine';
import { CACHE_KEYS } from '@/constants/cache-keys';
import { useFeatureFlagsState } from '@/hooks/useFeatureFlags';

export interface AlertRulesAvailability {
    alertsEnabled: boolean;
    hasAlertRules: boolean;
    isLoading: boolean;
}

export function useAlertRulesAvailability(
    sourceId?: string,
): AlertRulesAvailability {
    const { flags, isLoading: flagsLoading } = useFeatureFlagsState();
    const alertsEnabled = !flagsLoading && flags.alertsEnabled;

    const isSourceScoped = sourceId !== undefined;
    const shouldFetch = alertsEnabled && (!isSourceScoped || Boolean(sourceId));

    const { data, isLoading: rulesLoading } = useSWR(
        shouldFetch
            ? isSourceScoped
                ? [CACHE_KEYS.ALERT_RULES_CHECK, sourceId]
                : [CACHE_KEYS.ALERT_RULES_CHECK]
            : null,
        () =>
            EngineService.getAlertRules(
                isSourceScoped
                    ? { sourceId, size: 1 }
                    : { active: true, size: 1 },
            ),
        { revalidateOnFocus: false, dedupingInterval: 60000 },
    );

    const hasAlertRules = alertsEnabled && (data?.page?.totalItems ?? 0) > 0;
    const isLoading = flagsLoading || rulesLoading;

    return { alertsEnabled, hasAlertRules, isLoading };
}
